/**
 * 日志打印类.
 *
 * @author  yusangeng@outlook.com
 *
 * @fileoverview
 * Logger生成日志, Driver打印日志.
 */
import { __spreadArray } from "tslib";
import dateFormat from "dateformat";
import g from "./global";
import config from "./config";
import { anything2LevelString } from "./levelHelper";
var assign = Object.assign;
var notSupportColor = (function (env) { return !env.location || !!env.ActiveXObject; })(g);
var colorTable = {
    DEBUG: "#3CABDB",
    INFO: "#167FFC",
    WARN: "#595BD4",
    ERROR: "#FD3259"
};
var colorfulStyles = {
    level: function (level) {
        var bg = colorTable[level];
        if (typeof bg !== "string") {
            bg = "#3CABDB";
        }
        return "color: #FFF; background:".concat(bg, ";");
    },
    module: function ( /*moduleName: string*/) {
        return "color: #6C6B47;";
    },
    time: function ( /*now: string*/) {
        return "color: #6C6B47;";
    },
    content: function ( /*content: string*/) {
        return "color: #0C0C0C;";
    }
};
var levelTextTable = {
    DEBUG: "DBG",
    INFO: "INF",
    WARN: "WRN",
    ERROR: "ERR"
};
function level2Text(levelStr) {
    var text = levelTextTable[levelStr];
    if (typeof text !== "string") {
        text = "#3CABDB";
    }
    return text;
}
function getConsoleLogFunctionByLevel(levelStr) {
    if (levelStr === "DEBUG") {
        return console.debug.bind(console);
    }
    else if (levelStr === "INFO") {
        return console.info.bind(console);
    }
    else if (levelStr === "WARN") {
        return console.warn.bind(console);
    }
    else if (levelStr === "ERROR") {
        return console.error.bind(console);
    }
    else {
        return console.log.bind(console);
    }
}
var Driver = /** @class */ (function () {
    function Driver(conf) {
        var myConf = assign({}, config, conf);
        var flags = myConf["chivy-driver-flags"];
        this.noColor = notSupportColor || !flags.find(function (el) { return el === "color"; });
        this.noTime = !flags.find(function (el) { return el === "time"; });
        this.noModule = !flags.find(function (el) { return el === "module"; });
        this.noLevel = !flags.find(function (el) { return el === "level"; });
        this.cstyles_ = colorfulStyles;
    }
    Driver.prototype.log = function (level, moduleName) {
        var params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            params[_i - 2] = arguments[_i];
        }
        if (!this.noColor) {
            // 彩色打印
            this.colorfully.apply(this, __spreadArray([level, moduleName], params, false));
        }
        else {
            this.monochromatically.apply(this, __spreadArray([level, moduleName], params, false));
        }
    };
    Driver.prototype.colorfully = function (level, moduleName) {
        var params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            params[_i - 2] = arguments[_i];
        }
        var levelStr = anything2LevelString(level) || "" + level;
        var paddingLevelStr = level2Text(levelStr);
        var now = dateFormat(new Date(), "HH:mm:ss:l");
        var p0 = params[0];
        var prefix = [];
        var styleParams = [];
        if (!this.noLevel) {
            prefix.push("%c ".concat(paddingLevelStr));
            styleParams.push(this.cstyles_.level(levelStr));
        }
        if (!this.noModule) {
            prefix.push("%c ".concat(moduleName));
            styleParams.push(this.cstyles_.module(moduleName));
        }
        if (!this.noTime) {
            prefix.push("%c ".concat(now));
            styleParams.push(this.cstyles_.time(now));
        }
        var log = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            console.log.apply(console, args);
        };
        if (params.length !== 1) {
            log.apply(void 0, __spreadArray(["".concat(prefix.join(" "), " ----")], styleParams, false));
            log.apply(void 0, params);
            return;
        }
        var content0 = "".concat(prefix.join(" "), "%c - ").concat("" + p0);
        if (typeof p0 === "string") {
            log.apply(void 0, __spreadArray([content0], styleParams.concat([this.cstyles_.content(p0)]), false));
            return;
        }
        if (typeof p0 === "number") {
            log.apply(void 0, __spreadArray([content0], styleParams.concat([this.cstyles_.content("" + p0)]), false));
            return;
        }
        if (typeof p0 === "boolean") {
            log.apply(void 0, __spreadArray([content0], styleParams.concat([this.cstyles_.content(p0 ? "true" : "false")]), false));
            return;
        }
        log.apply(void 0, __spreadArray(["".concat(prefix.join(" "), " ----")], styleParams, false));
        log.apply(void 0, params);
    };
    Driver.prototype.monochromatically = function (level, moduleName) {
        var params = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            params[_i - 2] = arguments[_i];
        }
        var levelStr = anything2LevelString(level) || "" + level;
        var paddingLevelStr = level2Text(levelStr);
        var now = dateFormat(new Date(), "HH:mm:ss:l");
        var p0 = params[0];
        var prefix = [];
        if (!this.noLevel) {
            prefix.push("[".concat(paddingLevelStr, "]"));
        }
        if (!this.noModule) {
            prefix.push("[".concat(moduleName, "]"));
        }
        if (!this.noTime) {
            prefix.push("[".concat(now, "]"));
        }
        var log = getConsoleLogFunctionByLevel(levelStr);
        if (params.length === 1 &&
            ["string", "number", "boolean"].includes(typeof p0)) {
            log("".concat(prefix.join(" "), " - ").concat(p0));
        }
        else {
            log("".concat(prefix.join(" ")));
            log.apply(void 0, params);
        }
    };
    return Driver;
}());
export default Driver;
//# sourceMappingURL=data:application/json;base64,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